import { Oval } from "react-loader-spinner";
import "./style.css";

/* Brand spinner. Was a hardcoded #734792 purple that appears nowhere in the
   palette; these are the same values the other converted apps use. */
const SPINNER = {
  color: "#F49038",
  secondaryColor: "#FDE9D8",
  strokeWidth: 2,
  strokeWidthSecondary: 2,
  visible: true,
  ariaLabel: "oval-loading",
};

const PageLoader = () => {
  return (
    <div className="fixed left-0 top-0 z-[55] flex h-screen w-screen items-center justify-center bg-surface/80">
      <Oval height={80} width={80} {...SPINNER} />
    </div>
  );
};

export default PageLoader;

/**
 * Covers its positioned parent. It was `absolute` but still sized
 * `w-screen h-screen`, so it blanked the whole viewport instead of the
 * component it belongs to.
 */
export const ComponentLoader = () => {
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-card/80">
      <Oval height={48} width={48} {...SPINNER} />
    </div>
  );
};

export const Loader = () => {
  return <Oval height={80} width={80} {...SPINNER} />;
};
